<script>
  import liberarSolicitacoesServico from '../servico';
  import $ from 'jquery';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import projetoServico from '~modulos/projeto/servico';
  import solicitacaoCores from '~js/solicitacao-cores';

  import Pagamento from './compartilhado/LiberarSolicitacaoPagamentoPfLista.vue';
  import Pagamentopj from './compartilhado/LiberarSolicitacaoPagamentoPJLista.vue';
  import Adiantamento from './compartilhado/LiberarSolicitacaoAdiantamentoLista.vue';
  import Bolsa from './compartilhado/LiberarSolicitacaoBolsaLista.vue';
  import Compra from './compartilhado/LiberarSolicitacaoCompraLista.vue';
  import Reembolso from './compartilhado/LiberarSolicitacaoReembolsoLista.vue';
  import Faturamento from './compartilhado/LiberarSolicitacaoFaturamentoLista.vue';
  import Faturamentomc from './compartilhado/LiberarSolicitacaoFaturamentoMCLista.vue';
  import ReembolsoTerceiro from './compartilhado/LiberarSolicitacaoReembolsoTerceiroLista.vue';
  import SemLista from './compartilhado/LiberarSolicitacaoSemLista.vue';
  import CursoEventoDoacaoServico from './compartilhado/LiberarSolicitacaoCursoEventoDoacaoServicoLista.vue';
  import Pagamentoestrangeiropf from './compartilhado/LiberarSolicitacaoPagamentoEstrangeiroPf.vue';
  import Pagamentoestrangeiropj from './compartilhado/LiberarSolicitacaoPagamentoEstrangeiroPJ.vue';
  import Transferencia from './compartilhado/LiberarSolicitacaoTransferenciaLista.vue';
  import CancelamentoContrato from './compartilhado/LiberarSolicitacaoCancelamentoContratoLista.vue';
  import Importacao from './compartilhado/LiberarSolicitacaoImportacaoLista.vue';
  import ContratacaoPessoal from './compartilhado/LiberarSolicitacaoContratacaoPessoalLista.vue';

  export default {
    components: { 
      Pagamento,
      Pagamentopj,
      Adiantamento,
      Bolsa,
      Compra,
      Reembolso,
      Faturamento,
      Faturamentomc,
      ReembolsoTerceiro,
      SemLista,
      CursoEventoDoacaoServico,
      Pagamentoestrangeiropf,
      Pagamentoestrangeiropj,
      Transferencia,
      CancelamentoContrato,
      Importacao,
      ContratacaoPessoal,
    },
    data() {
      return {
        solicitacoes: [],
        carregando: true,
        solicitacaoSelecionada: null,
        animated: true,
        configuracao: this.$storage.configuracao(),
        filtros: this.camposFiltros(),
        projetos: [],

        mostrarAdiantamento: false,
        mostrarBolsa: false,
        mostrarCompra: false,
        mostrarReembolso: false,
        mostrarFaturamento: false,
        mostrarFaturamentoMC: false, 
        mostrarPgtoPF: false,
        mostrarPgtoPJ: false,
        mostrarReembolsoTerceiro: false,
        mostrarSemSolicitacao: false,
        mostrarCursoEventoServicoDoacao: false,
        mostrarPgtoEstrangeiroPF: false,
        mostrarPgtoEstrangeiroPJ: false,
        mostrarTransferencia: false,
        mostrarCancelamentoContrato: false,
        mostrarImportacao: false,
        mostrarContratacaoPessoal: false,

        solicitacaoCores: solicitacaoCores,
      }
    },
    methods: {
      retornaClassIcone(modulo) {        
        return this.solicitacaoCores.filter(s => s.id == modulo)[0].icone;
      },
      retornaClassCor(modulo) {
        return this.solicitacaoCores.filter(s => s.id == modulo)[0].cor + "29"; 
      },
      listaDeProjetos() {
        return projetoServico
          .listaDeAcessos()
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      camposFiltros() {
        return {
          IdProjeto: 0,
        };
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.$nextTick(() => {
          $('#projeto').val(0);
          $('#projeto').trigger('change.select2');
        });

        this.lista();
      },
      mostrarEsconderFiltro(e) {
        if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
          $('.collapse-link').trigger('click');
        }
      },
      limparSolicitacoes() {
        this.mostrarAdiantamento = false;
        this.mostrarBolsa = false;
        this.mostrarCompra = false;
        this.mostrarReembolso = false;
        this.mostrarFaturamento = false;
        this.mostrarFaturamentoMC = false;
        this.mostrarPgtoPF = false;
        this.mostrarPgtoPJ = false;
        this.mostrarReembolsoTerceiro = false;
        this.mostrarCursoEventoServicoDoacao = false;
        this.mostrarPgtoEstrangeiroPF = false;
        this.mostrarPgtoEstrangeiroPJ = false;
        this.mostrarTransferencia = false;
        this.mostrarCancelamentoContrato = false;
        this.mostrarImportacao = false;
        this.mostrarContratacaoPessoal = false;
      },
      lista() {
        this.carregando = true;
        this.limparSolicitacoes();

        return liberarSolicitacoesServico.lista(this.filtros)
          .then(res => {
            this.carregando = false;

            this.solicitacoes = res;
            this.setarVisibilidade();

            $('body')
              .css('overflow', 'scroll');
          });
      },
      setarVisibilidade() {
        this.mostrarAdiantamento = (this.solicitacoes.solAdiantamento.length > 0);
        this.mostrarBolsa = (this.solicitacoes.solBolsa.length > 0);
        this.mostrarCompra = (this.solicitacoes.solCompra.length > 0);
        this.mostrarReembolso = (this.solicitacoes.solReembolso.length > 0);
        this.mostrarFaturamento = (this.solicitacoes.solFaturamento.length > 0);
        this.mostrarFaturamentoMC = (this.solicitacoes.solFaturamentoMC.length > 0);
        this.mostrarPgtoPF = (this.solicitacoes.solPagamentoPF.length > 0);
        this.mostrarPgtoPJ = (this.solicitacoes.solPagamentoPJ.length > 0);
        this.mostrarPgtoEstrangeiroPF = (this.solicitacoes.solPagamentoEstrangeiroPF.length > 0);
        this.mostrarPgtoEstrangeiroPJ = (this.solicitacoes.solPagamentoEstrangeiroPJ.length > 0);
        this.mostrarReembolsoTerceiro = (this.solicitacoes.solReembolsoTerceiro.length > 0);
        this.mostrarCursoEventoServicoDoacao = (this.solicitacoes.solCursoEventoServicoDoacao.length > 0);
        this.mostrarTransferencia = (this.solicitacoes.solTransferencia.length > 0);
        this.mostrarCancelamentoContrato = (this.solicitacoes.solCancelamentoContrato.length > 0);
        this.mostrarImportacao  = (this.solicitacoes.solImportacao.length > 0);
        this.mostrarContratacaoPessoal  = (this.solicitacoes.solContratacaoPessoal.length > 0);
        this.mostrarSemSolicitacao = !(this.mostrarAdiantamento ||
                                        this.mostrarBolsa ||
                                        this.mostrarCompra ||
                                        this.mostrarReembolso ||
                                        this.mostrarFaturamento ||
                                        this.mostrarFaturamentoMC ||
                                        this.mostrarPgtoPF ||
                                        this.mostrarPgtoPJ ||
                                        this.mostrarPgtoEstrangeiroPF ||
                                        this.mostrarPgtoEstrangeiroPJ ||
                                        this.mostrarReembolsoTerceiro ||
                                        this.mostrarCursoEventoServicoDoacao ||
                                        this.mostrarTransferencia ||
                                        this.mostrarCancelamentoContrato ||
                                        this.mostrarImportacao ||
                                        this.mostrarContratacaoPessoal
                                      );
      },
    },
    created() {
      this.lista();
    },
    mounted() {
      this.$root.tituloDaPagina = 'Liberar Solicitações - Lista';
      this.$root.botaoAcaoMostrar = false;

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.listaDeProjetos();

      const _this = this;

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function (e) {
        _this.$set(_this.filtros, 'IdProjeto', this.value);
        });
    },
    watch: {
      '$route': 'lista'
    },
  }
</script>

<template>

  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox collapsed float-e-margins" id="filter">
          <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
            <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

            <div class="ibox-tools">
              <span class="collapse-link">
                <i class="fa fa-chevron-up"></i>
              </span>
            </div>
          </div>

          <div class="ibox-content">

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label class="control-label" for="projeto">Projeto</label>

                  <select id="projeto"
                          class="form-control"
                          v-model="filtros.IdProjeto">
                    <option value="0">Todos</option>
                    <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group no-margins">
                  <button type="button" class="btn btn-success no-margins" @click="lista">
                    <i class="fa fa-search"></i>
                    Filtrar
                  </button>
                  <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                    <i class="fa fa-eraser"></i>
                    Limpar filtros
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox-footer">

            <div v-if="carregando">
              <div class="btn-group btn-group-justified  hidden-print" role="group">
                <div class="btn-group" role="group">
                  <button type="button" :class="['btn btn-outline-primary', {'active': true}]" style="background-color: #d3d3d347">
                    <i class="fa fa-spinner fa-pulse"></i>  Carregando...
                  </button>
                </div>
              </div>
            </div>

            <div v-if="mostrarAdiantamento">
              <div class="btn-group btn-group-justified  hidden-print" role="group">
                <div class="btn-group" role="group">
                  <button type="button" :class="['btn btn-outline-primary', {'active': true}]" :style="{ 'background-color': retornaClassCor(5) }">
                    <i :class="retornaClassIcone(5)"></i>  Solicitação de Adiantamento
                  </button>
                </div>
              </div>

              <adiantamento ref="Adiantamento"
                            :solicitacoes.sync="solicitacoes.solAdiantamento"
                            :projetos="projetos"
                            @lista="lista"
                            v-if="mostrarAdiantamento">
              </adiantamento>

              <div class="hr-line-dashed margin-top-5"></div>

            </div>

            <div v-if="mostrarBolsa">
              <div class="btn-group btn-group-justified  hidden-print" role="group">
                <div class="btn-group" role="group">
                  <button type="button" :class="['btn btn-outline-primary', {'active': true}]" :style="{ 'background-color': retornaClassCor(2) }">
                    <i :class="retornaClassIcone(2)"></i>  {{ 'Solicitação de ' + configuracao.nomeModuloSolContratos }}
                  </button>
                </div>
              </div>

              <bolsa ref="Bolsa"
                     :solicitacoes.sync="solicitacoes.solBolsa"
                     :projetos="projetos"
                     @lista="lista"
                     v-if="mostrarBolsa">
              </bolsa>

              <div class="hr-line-dashed margin-top-5"></div>

            </div>

            <div v-if="mostrarCompra">
              <div class="btn-group btn-group-justified  hidden-print" role="group">
                <div class="btn-group" role="group">
                  <button type="button" :class="['btn btn-outline-primary', {'active': true}]" :style="{ 'background-color': retornaClassCor(1) }">
                    <i :class="retornaClassIcone(1)"></i>  Solicitação de Compra
                  </button>
                </div>
              </div>

              <compra ref="Compra"
                      :solicitacoes.sync="solicitacoes.solCompra"
                      :projetos="projetos"
                      @lista="lista"
                      v-if="mostrarCompra">
              </compra>

              <div class="hr-line-dashed margin-top-5"></div>

            </div>

            <div v-if="mostrarContratacaoPessoal">
              <div class="btn-group btn-group-justified  hidden-print" role="group">
                <div class="btn-group" role="group">
                  <button type="button" :class="['btn btn-outline-primary', {'active': true}]" :style="{ 'background-color': retornaClassCor(18) }">
                    <i :class="retornaClassIcone(18)"></i>  Solicitação de Contratação Pessoal
                  </button>
                </div>
              </div>

              <contratacaoPessoal ref="ContratacaoPessoal"
                      :solicitacoes.sync="solicitacoes.solContratacaoPessoal"
                      :projetos="projetos"
                      @lista="lista"
                      v-if="mostrarContratacaoPessoal">
              </contratacaoPessoal>

              <div class="hr-line-dashed margin-top-5"></div>

            </div>

            <div v-if="mostrarCursoEventoServicoDoacao">
              <div class="btn-group btn-group-justified  hidden-print" role="group">
                <div class="btn-group" role="group">
                  <button type="button" :class="['btn btn-outline-primary', {'active': true}]" :style="{ 'background-color': retornaClassCor(3) }">
                    <i :class="retornaClassIcone(3)"></i>  {{ 'Solicitação de ' + configuracao.nomeModuloSolCursoEventoServico }}
                  </button>
                </div>
              </div>

              <cursoEventoDoacaoServico ref="CursoEventoDoacaoServico"
                                        :solicitacoes.sync="solicitacoes.solCursoEventoServicoDoacao"
                                        @lista="lista"
                                        v-if="mostrarCursoEventoServicoDoacao">
              </cursoEventoDoacaoServico>

              <div class="hr-line-dashed margin-top-5"></div>

            </div>

            <div v-if="mostrarReembolso">
              <div class="btn-group btn-group-justified  hidden-print" role="group">
                <div class="btn-group" role="group">
                  <button type="button" :class="['btn btn-outline-primary', {'active': true}]" :style="{ 'background-color': retornaClassCor(6) }">
                    <i :class="retornaClassIcone(6)"></i>  Solicitação de Diária {{ configuracao.utilizarSolicitacaoAdiantamentoPassagemWeb ? ' - Passagem' : '' }} {{ configuracao.utilizarSolicitacaoAdiantamentoWeb ? ' - Adiantamento' : '' }}
                  </button>
                </div>
              </div>

              <reembolso ref="Reembolso"
                         :solicitacoes.sync="solicitacoes.solReembolso"
                         :projetos="projetos"
                         @lista="lista"
                         v-if="mostrarReembolso">
              </reembolso>

              <div class="hr-line-dashed margin-top-5"></div>

            </div>

            <div v-if="mostrarFaturamento">
              <div class="btn-group btn-group-justified  hidden-print" role="group">
                <div class="btn-group" role="group">
                  <button type="button" :class="['btn btn-outline-primary', {'active': true}]" :style="{ 'background-color': retornaClassCor(7) }">
                    <i :class="retornaClassIcone(7)"></i>  Solicitação de Faturamento
                  </button>
                </div>
              </div>

              <faturamento ref="Faturamento"
                           :solicitacoes.sync="solicitacoes.solFaturamento"
                           :projetos="projetos"
                           @lista="lista"
                           v-if="mostrarFaturamento">
              </faturamento>

              <div class="hr-line-dashed margin-top-5"></div>

            </div>

            <div v-if="mostrarFaturamentoMC">
              <div class="btn-group btn-group-justified  hidden-print" role="group">
                <div class="btn-group" role="group">
                  <button type="button" :class="['btn btn-outline-primary', {'active': true}]" :style="{ 'background-color': retornaClassCor(7) }">
                    <i :class="retornaClassIcone(7)"></i>  Solicitação de Faturamento Multiserviços
                  </button>
                </div>
              </div>

              <faturamentomc ref="Faturamentomc"
                             :solicitacoes.sync="solicitacoes.solFaturamentoMC"
                             @lista="lista"
                             v-if="mostrarFaturamentoMC">
              </faturamentomc>

              <div class="hr-line-dashed margin-top-5"></div>

            </div>

            <div v-if="mostrarImportacao">
              <div class="btn-group btn-group-justified  hidden-print" role="group">
                <div class="btn-group" role="group">
                  <button type="button" :class="['btn btn-outline-primary', {'active': true}]" :style="{ 'background-color': retornaClassCor(8) }">
                    <i :class="retornaClassIcone(8)"></i>  Solicitação de Importação
                  </button>
                </div>
              </div>

              <importacao ref="Importacao"
                          :solicitacoes.sync="solicitacoes.solImportacao"
                          @lista="lista"
                          v-if="mostrarImportacao">
              </importacao>

              <div class="hr-line-dashed margin-top-5"></div>

            </div>

            <div v-if="mostrarPgtoPF">
              <div class="btn-group btn-group-justified  hidden-print" role="group">
                <div class="btn-group" role="group">
                  <button type="button" :class="['btn btn-outline-primary', {'active': true}]" :style="{ 'background-color': retornaClassCor(4) }">
                    <i :class="retornaClassIcone(4)"></i>  Solicitações de Pagamento - Pessoas Físicas
                  </button>
                </div>
              </div>

              <pagamento ref="Pagamento"
                         :solicitacoes.sync="solicitacoes.solPagamentoPF"
                         :projetos="projetos"
                         @lista="lista"
                         v-if="mostrarPgtoPF">
              </pagamento>

              <div class="hr-line-dashed margin-top-5"></div>
            </div>

            <div v-if="mostrarPgtoPJ">
              <div class="btn-group btn-group-justified  hidden-print" role="group">
                <div class="btn-group" role="group">
                  <button type="button" :class="['btn btn-outline-primary', {'active': true}]" :style="{ 'background-color': retornaClassCor(9) }">
                    <i :class="retornaClassIcone(9)"></i>  Solicitações de Pagamento - Pessoas Jurídicas
                  </button>
                </div>
              </div>

              <pagamentopj ref="Pagamentopj"
                           :solicitacoes.sync="solicitacoes.solPagamentoPJ"
                           :projetos="projetos"
                           @lista="lista"
                           v-if="mostrarPgtoPJ">
              </pagamentopj>

              <div class="hr-line-dashed margin-top-5"></div>
            </div>

            <div v-if="mostrarPgtoEstrangeiroPF">
              <div class="btn-group btn-group-justified  hidden-print" role="group">
                <div class="btn-group" role="group">
                  <button type="button" :class="['btn btn-outline-primary', {'active': true}]" :style="{ 'background-color': retornaClassCor(13) }">
                    <i :class="retornaClassIcone(13)"></i>  Solicitações de Pagamento - Estrangeiro PF
                  </button>
                </div>
              </div>
              <pagamentoestrangeiropf ref="Pagamentoestrangeiropf"
                                      :solicitacoes.sync="solicitacoes.solPagamentoEstrangeiroPF"
                                      :projetos="projetos"
                                      @lista="lista"
                                      v-if="mostrarPgtoEstrangeiroPF">
              </pagamentoestrangeiropf>
              <div class="hr-line-dashed margin-top-5"></div>
            </div>

            <div v-if="mostrarPgtoEstrangeiroPJ">
              <div class="btn-group btn-group-justified  hidden-print" role="group">
                <div class="btn-group" role="group">
                  <button type="button" :class="['btn btn-outline-primary', {'active': true}]" :style="{ 'background-color': retornaClassCor(14) }">
                    <i :class="retornaClassIcone(14)"></i>  Solicitações de Pagamento - Estrangeiro PJ
                  </button>
                </div>
              </div>
              <pagamentoestrangeiropj ref="Pagamentoestrangeiropj"
                                      :solicitacoes.sync="solicitacoes.solPagamentoEstrangeiroPJ"
                                      :projetos="projetos"
                                      @lista="lista"
                                      v-if="mostrarPgtoEstrangeiroPJ">
              </pagamentoestrangeiropj>
              <div class="hr-line-dashed margin-top-5"></div>
            </div>

            <div v-if="mostrarReembolsoTerceiro">
              <div class="btn-group btn-group-justified  hidden-print" role="group">
                <div class="btn-group" role="group">
                  <button type="button" :class="['btn btn-outline-primary', {'active': true}]" :style="{ 'background-color': retornaClassCor(10) }">
                    <i :class="retornaClassIcone(10)"></i>  Solicitações de Reembolso Terceiros
                  </button>
                </div>
              </div>

              <reembolso-terceiro ref="ReembolsoTerceiro"
                                  :solicitacoes.sync="solicitacoes.solReembolsoTerceiro"
                                  :projetos="projetos"
                                  @lista="lista"
                                  v-if="mostrarReembolsoTerceiro">
              </reembolso-terceiro>

              <div class="hr-line-dashed margin-top-5"></div>

            </div>

            <div v-if="mostrarTransferencia">
              <div class="btn-group btn-group-justified  hidden-print" role="group">
                <div class="btn-group" role="group">
                  <button type="button" :class="['btn btn-outline-primary', {'active': true}]" :style="{ 'background-color': retornaClassCor(15) }">
                    <i :class="retornaClassIcone(15)"></i>  Solicitações de Transferência
                  </button>
                </div>
              </div>

              <transferencia ref="Transferencia"
                             :solicitacoes.sync="solicitacoes.solTransferencia"
                             @lista="lista"
                             v-if="mostrarTransferencia">
              </transferencia>

              <div class="hr-line-dashed margin-top-5"></div>

            </div>

            <div v-if="mostrarCancelamentoContrato">
              <div class="btn-group btn-group-justified  hidden-print" role="group">
                <div class="btn-group" role="group">
                  <button type="button" :class="['btn btn-outline-primary', {'active': true}]" :style="{ 'background-color': retornaClassCor(16) }">
                    <i :class="retornaClassIcone(16)"></i>  Solicitações de Cancelamento Contrato
                  </button>
                </div>
              </div>

              <cancelamento-contrato ref="CancelamentoContrato"
                                     :solicitacoes.sync="solicitacoes.solCancelamentoContrato"
                                     @lista="lista"
                                     v-if="mostrarCancelamentoContrato">
              </cancelamento-contrato>

              <div class="hr-line-dashed margin-top-5"></div>

            </div>

            <div v-if="mostrarSemSolicitacao">
              <sem-Lista ref="SemLista"
                         :solicitacoes.sync="solicitacoes"
                         @lista="lista"
                         v-if="mostrarSemSolicitacao">
              </sem-Lista>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/liberar-solicitacoes/componentes/LiberarSolicitacoes.vue